import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import IllustrationRouter from '../../illustrations/routers/IllustrationRouter';
import TileLogoRouter from './../../tile_logo/routers/TileLogoRouter'
import SideBar from '../components/Sidebar';
import routes from '../models/route-constants';
import NotFoundPage from '../pages/NotFoundPage';
import HelpRouter from '../../help/routers/HelpRouter.js';
import IconRouter from '../../icons/routers/IconRouter';
import AnimatedAssetsRouter from '../../animated_assets/routers/AnimatedAssetsRouter';
import IllustrationApp from '../../illustration_tool/IllustrationApp.js';
import AdminsPage from '../pages/AdminsPage';

function appendHash(pathname) {
    return "/".concat(pathname)
}

function HomeRouter({ signOut }) {
    const { pathname } = useLocation();
    return (
        <div id='rootContainer'>
            <SideBar signOut={signOut} />
            <div id='content-main'>
                <Switch>
                    <Redirect from='/:url*(/+)' to={pathname.slice(0, -1)} />
                    <Route exact path='/'>
                        <Redirect to={appendHash(routes.ILLUSTRATIONS)} />
                    </Route>
                    <Route path={appendHash(routes.ILLUSTRATIONS)}>
                        <IllustrationRouter />
                    </Route>
                    <Route path={appendHash(routes.ICONS)}>
                        <IconRouter />
                    </Route>
                    <Route path={appendHash(routes.TILE_LOGO)}>                       
                        <TileLogoRouter />
                    </Route>
                    <Route path={appendHash(routes.ANIMATED_ASSETS)}>
                        <AnimatedAssetsRouter />
                    </Route>
                    <Route path={appendHash(routes.HELP)}>
                        <HelpRouter />
                    </Route>
                    <Route path={appendHash(routes.ILLUSTRATION_BUILDER)}>
                        <IllustrationApp />
                    </Route>
                    <Route path={appendHash(routes.ADMINS)}>
                        <AdminsPage />
                    </Route>
                    <Route path='*'>
                        <NotFoundPage />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}

export default HomeRouter;
